import React from "react";
import { format } from "date-fns";
import DayRemain from "../../icons/dayRemain";
import StripeElements from "./stripeElements";
import styles from "./style.module.css";

const Payments = ({ trialDays, membershipAmount }) => {
  return (
    <div className={styles.main}>
      <div className={styles.body_view}>
        <div className={styles.body_view_inner}>
          <div className={styles.payment_box_row}>
            <div className={styles.payment_box}>
              <div className={styles.payment_box_icon}>
                <div className={styles.payment_box_icon_day}>
                  <DayRemain />
                  <div className={styles.payment_box_icon_day_text}>
                    {trialDays}
                  </div>
                </div>
                <div className={styles.payment_box_icon_text}>
                  Days Remaining
                </div>
              </div>
              <div className={styles.payment_box_des}>
                We offer a <strong>{trialDays}-day free trial period</strong>,
                during which you can evaluate our services at your leisure. You
                will be charged <strong>${membershipAmount}</strong> on{" "}
                <strong>
                  {format(
                    new Date(Date.now() + trialDays * 24 * 60 * 60 * 1000),
                    "MMMM dd, yyyy"
                  )}
                </strong>
                .
              </div>
            </div>
            <div className={styles.payment_card}>
              <StripeElements
                membershipAmount={membershipAmount}
                trialDays={trialDays}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Payments;
